<template>
  <div class="property_wrap">
    <div class="pro_top">多行文本</div>
    <div class="pro_con">
      <el-form ref="form" :model="form" label-width="80px">
        <el-form-item label="提示语:">
          <el-input v-model="property.name" maxlength="20" show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="字数限制:">
          <el-input v-model="property.num" maxLength='3'>
            <template slot="append">字</template>
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-checkbox v-model="property.checked">设为必填项</el-checkbox>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
export default {
  props: ["property"],
  data() {
    return {
      form: {}
    };
  }
};
</script>

 